interface NamedRole {
    name: string;
}

/**
 * Org admins act with every role granted to their organization; everyone else acts with
 * their own user roles. The router guard and in-page permission checks share this rule.
 */
export function hasEffectiveRole(userRoles: NamedRole[], orgRoles: NamedRole[], allowedRoles: string[]): boolean {
    const isOrgAdmin = userRoles.some((role) => role.name === 'org-admin');
    const effectiveRoles = (isOrgAdmin ? orgRoles : userRoles).map((role) => role.name);
    return allowedRoles.some((role) => effectiveRoles.includes(role));
}
